
  import React from "react"
  import Component from "D:/Projects/Git/Website/AlexMathisPortfolio/src/layouts/index.js"
  import data from "D:\\Projects\\Git\\Website\\AlexMathisPortfolio\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js